<div
  class="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] flex flex-col gap-2.5 w-[calc(100%-32px)] max-w-[480px] pointer-events-none"
>
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="toast"
      [class.toast-success]="toast.type === 'success'"
      [class.toast-error]="toast.type === 'error'"
    >
      @if (toast.type === 'success') {
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-5 h-5 shrink-0"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      } @else {
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-5 h-5 shrink-0"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      }

      <span class="flex-1 font-body text-[14px] font-medium leading-[1.4]">{{
        toast.message
      }}</span>

      <button
        class="bg-transparent border-0 cursor-pointer p-0.5 text-current opacity-50 flex items-center justify-center shrink-0 transition-opacity duration-200 hover:opacity-100"
        (click)="toastService.dismiss(toast.id)"
        aria-label="Cerrar"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-4 h-4"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  }
</div>
